import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo_white.png';

const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.4 0 10.3-2.1 14-5.5l-6.5-5.3C29.6 34.7 26.9 36 24 36c-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.6 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.5 5.3C40.9 35.6 44 30.3 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

const PortalLoginShell = ({
  portalLabel,
  title,
  description,
  accent = '#00bf63',
  Icon,
  onGoogleSignIn,
  loading = false,
  error = '',
  footerHint,
  otherPortals = [],
}) => (
  <div style={{
    minHeight: '100vh',
    fontFamily: 'Plus Jakarta Sans, sans-serif',
    display: 'flex',
    alignItems: 'stretch',
    background: '#0f172a',
  }}>
    {/* Left: brand panel */}
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '48px 56px',
      background: 'radial-gradient(ellipse at top right, rgba(193,255,114,0.10), transparent 60%), radial-gradient(ellipse at bottom left, rgba(0,191,99,0.10), transparent 50%), #0f172a',
      color: 'white',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <Link to="/all" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
        <img src={logo} alt="Loysta" style={{ height: 30 }} />
      </Link>

      <div style={{ position: 'relative', zIndex: 2 }}>
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 12px',
          borderRadius: 999,
          background: 'rgba(193,255,114,0.10)',
          border: '1px solid rgba(193,255,114,0.20)',
          color: '#c1ff72',
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          marginBottom: 18,
        }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#c1ff72' }} />
          {portalLabel}
        </div>
        <h1 style={{
          fontSize: 40,
          fontWeight: 800,
          letterSpacing: '-0.02em',
          lineHeight: 1.15,
          margin: '0 0 16px 0',
          color: 'white',
        }}>
          {title}
        </h1>
        <p style={{
          fontSize: 16,
          color: 'rgba(255,255,255,0.6)',
          lineHeight: 1.65,
          margin: 0,
          maxWidth: 460,
        }}>
          {description}
        </p>
      </div>

      <div style={{ color: 'rgba(255,255,255,0.32)', fontSize: 12 }}>
        © Loysta — employee benefits, made simple.
      </div>
    </div>

    {/* Right: card */}
    <div style={{
      width: '100%',
      maxWidth: 480,
      background: '#f8fafc',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 40px',
    }}>
      <div style={{
        width: '100%',
        maxWidth: 360,
        display: 'flex',
        flexDirection: 'column',
        gap: 22,
      }}>
        <div>
          <div style={{
            width: 52,
            height: 52,
            borderRadius: 14,
            background: accent + '18',
            color: accent,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 18,
          }}>
            {Icon ? <Icon size={24} /> : null}
          </div>
          <h2 style={{
            fontSize: 24,
            fontWeight: 800,
            color: '#0f172a',
            margin: '0 0 6px 0',
            letterSpacing: '-0.01em',
          }}>
            Sign in
          </h2>
          <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.6, margin: 0 }}>
            Use the Google account whitelisted by your platform administrator.
          </p>
        </div>

        {error && (
          <div style={{
            background: 'rgba(239,68,68,0.08)',
            border: '1px solid rgba(239,68,68,0.20)',
            color: '#dc2626',
            borderRadius: 10,
            padding: '12px 14px',
            fontSize: 13,
            lineHeight: 1.5,
          }}>
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={onGoogleSignIn}
          disabled={loading}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            padding: '14px 18px',
            border: '1.5px solid #e2e8f0',
            borderRadius: 12,
            background: 'white',
            color: '#0f172a',
            fontSize: 15,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: loading ? 'wait' : 'pointer',
            transition: 'all 0.15s ease',
            boxShadow: '0 1px 2px rgba(0,0,0,.04)',
          }}
          onMouseEnter={(e) => { if (!loading) e.currentTarget.style.borderColor = '#94a3b8'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; }}
        >
          <GoogleIcon />
          {loading ? 'Signing in…' : 'Sign in with Google'}
        </button>

        {footerHint && (
          <div style={{ fontSize: 12, color: '#94a3b8', lineHeight: 1.55 }}>
            {footerHint}
          </div>
        )}

        {otherPortals.length > 0 && (
          <div style={{
            paddingTop: 20,
            borderTop: '1px solid #e2e8f0',
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              Wrong portal?
            </div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {otherPortals.map((o) => (
                <Link
                  key={o.to}
                  to={o.to}
                  style={{
                    fontSize: 13,
                    color: '#475569',
                    textDecoration: 'none',
                    padding: '6px 12px',
                    borderRadius: 8,
                    border: '1px solid #e2e8f0',
                    background: 'white',
                    transition: 'all 0.15s',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = accent; e.currentTarget.style.color = accent; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.color = '#475569'; }}
                >
                  {o.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default PortalLoginShell;
